<button
  [id]="for"
  [class]="'th-btn-' + (btnType || 'primary-solid')"
  [ngClass]="{ small: small, nav: nav, subnav: subnav, icon: icon, active: active }"
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
